import { createFileRoute } from "@tanstack/react-router";
import { ParceriaPage } from "@/components/pages/ParceriaPage";
import { breadcrumbLd, serviceLd, ldScripts } from "@/lib/seo-jsonld";

const SITE = "https://kentro.com.br";
const URL = `${SITE}/parceria`;
const TITLE = "Programa de Parcerias Kentro — Seja um parceiro";
const DESC =
  "Torne-se parceiro Kentro: agências, integradores e revendas. Já é cliente? Indique pelo Clube Indica e ganhe recompensas a cada conversão.";

export const Route = createFileRoute("/parceria")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESC },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESC },
      { property: "og:url", content: URL },
      { property: "og:locale", content: "pt_BR" },
    ],
    links: [
      { rel: "canonical", href: URL },
      { rel: "alternate", hrefLang: "pt-BR", href: `${SITE}/parceria` },
      { rel: "alternate", hrefLang: "en", href: `${SITE}/en/parceria` },
      { rel: "alternate", hrefLang: "es", href: `${SITE}/es/parceria` },
      { rel: "alternate", hrefLang: "x-default", href: `${SITE}/parceria` },
    ],
    scripts: ldScripts(
      breadcrumbLd([
        { name: "Início", path: "/" },
        { name: "Parcerias", path: "/parceria" },
      ]),
      serviceLd({
        url: URL,
        name: "Programa de Parcerias Kentro",
        description: DESC,
        serviceType: "Programa de parceria para agências, integradores e revendas",
      }),
    ),
  }),
  component: ParceriaPage,
});
